import React, { useEffect, useState } from 'react';
import { Shield, Award, TrendingUp } from 'lucide-react';
export const ValuePropositions = () => {
  const [visibleCards, setVisibleCards] = useState([false, false, false]);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('services');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight - 100) {
          setVisibleCards([true, true, true]);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const cards = [{
    icon: <Shield size={48} className="text-blue-light" data-id="element-340" />,
    title: 'Experienced Professionals',
    description: 'Our skilled virtual assistants are trained in the art of persuasion and communication, bringing years of industry expertise to every campaign.'
  }, {
    icon: <Award size={48} className="text-blue-light" data-id="element-341" />,
    title: 'Quality Assurance',
    description: 'Our dedicated quality team verifies each lead, ensuring only qualified prospects reach your sales team, maximizing your conversion potential.'
  }, {
    icon: <TrendingUp size={48} className="text-blue-light" data-id="element-342" />,
    title: 'Competitive Pricing',
    description: "Affordable rates that don't sacrifice quality. Our pricing structure ensures you get maximum value without exceeding your budget."
  }];
  return <section id="services" className="relative py-20 bg-gradient-to-b from-black to-gray-900 w-full" data-id="element-343">
      {/* Animated background elements */}
      <div className="absolute inset-0" data-id="element-344">
        <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-345"></div>
        {/* Animated geometric shapes */}
        <div className="absolute top-20 left-20 w-40 h-40 border border-blue-primary/20 rotate-45 animate-spin" style={{
        animationDuration: '30s'
      }} data-id="element-346"></div>
        <div className="absolute bottom-20 right-20 w-60 h-60 border border-blue-light/20 rounded-full animate-pulse" style={{
        animationDuration: '15s'
      }} data-id="element-347"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-348">
        <div className="text-center mb-16" data-id="element-349">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-fadeIn" data-id="element-350">
            Why Choose{' '}
            <span className="text-blue-light relative" data-id="element-351">
              Callvana
              <span className="absolute -inset-1 bg-blue-light/10 blur-md -z-10 rounded-lg" data-id="element-352"></span>
            </span>
            ?
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto animate-fadeIn" style={{
          animationDelay: '0.2s'
        }} data-id="element-353">
            Our services are built on experience and enhanced with
            modern techniques to deliver unmatched results.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-354">
          {cards.map((card, index) => <div key={index} className={`bg-gray-900/80 border border-gray-800 rounded-lg p-8 transition-all duration-700 transform ${visibleCards[index] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'} hover:border-blue-light/50 group relative`} style={{
          transitionDelay: `${index * 200}ms`
        }} data-id="element-355">
              {/* Animated highlight on hover */}
              <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-primary to-blue-light rounded-lg blur opacity-0 group-hover:opacity-15 transition duration-1000 group-hover:duration-200" data-id="element-356"></div>
              <div className="flex flex-col items-center text-center relative" data-id="element-357">
                <div className="mb-4 p-4 rounded-full bg-gray-800 group-hover:bg-gradient-to-br group-hover:from-blue-primary/20 group-hover:to-blue-light/20 transition-all duration-300 relative" data-id="element-358">
                  <div className="animate-ping absolute inset-0 rounded-full bg-blue-primary/10 opacity-75" data-id="element-359"></div>
                  {card.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 group-hover:text-blue-light transition-colors" data-id="element-360">
                  {card.title}
                </h3>
                <p className="text-gray-400 group-hover:text-gray-300 transition-colors" data-id="element-361">
                  {card.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};